module.exports = __webpack_public_path__ + "media/images/business/img-feature-feed-85c4f19b80ab62c1e0d95118a4d3f697.png";